import React from "react";
import heroImage from "../../assets/HeroBanner.webp";

const Hero = () => {
  return (
    <>
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="overlay" />
        <div className="hero-content">
          <h1>Welcome to Porto Consulting</h1>
          <p>
            At Porto Consulting, we specialize in delivering innovative and tailored
            solutions for the <strong>Energy Sector</strong>, with specialization in{" "}
            <strong>nuclear power, oil & gas, data center industries, energy efficiency and
            management in buildings and communities</strong>. With a focus on safety,
            efficiency, and sustainability, our team is dedicated to driving excellence
            across all aspects of project execution and management.
          </p>
        </div>
      </section>
    </>
  );
};

export default Hero;
